function SaveIco() {
  return (
    <svg
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.5 1.5V3.2C3.5 3.48003 3.5 3.62004 3.5545 3.727C3.60243 3.82108 3.67892 3.89757 3.773 3.9455C3.87996 4 4.01997 4 4.3 4H7.7C7.98003 4 8.12004 4 8.227 3.9455C8.32108 3.89757 8.39757 3.82108 8.4455 3.727C8.5 3.62004 8.5 3.48003 8.5 3.2V2M8.5 10.5V7.3C8.5 7.01997 8.5 6.87996 8.4455 6.773C8.39757 6.67892 8.32108 6.60243 8.227 6.5545C8.12004 6.5 7.98003 6.5 7.7 6.5H4.3C4.01997 6.5 3.87996 6.5 3.773 6.5545C3.67892 6.60243 3.60243 6.67892 3.5545 6.773C3.5 6.87996 3.5 7.01997 3.5 7.3V10.5M10.5 4.66274V8.1C10.5 8.94008 10.5 9.36012 10.3365 9.68099C10.1927 9.96323 9.96323 10.1927 9.68099 10.3365C9.36012 10.5 8.94008 10.5 8.1 10.5H3.9C3.05992 10.5 2.63988 10.5 2.31901 10.3365C2.03677 10.1927 1.8073 9.96323 1.66349 9.68099C1.5 9.36012 1.5 8.94008 1.5 8.1V3.9C1.5 3.05992 1.5 2.63988 1.66349 2.31901C1.8073 2.03677 2.03677 1.8073 2.31901 1.66349C2.63988 1.5 3.05992 1.5 3.9 1.5H7.33726C7.58185 1.5 7.70414 1.5 7.81923 1.52763C7.92127 1.55213 8.01881 1.59253 8.10828 1.64736C8.2092 1.7092 8.29568 1.79568 8.46863 1.96863L10.0314 3.53137C10.2043 3.70432 10.2908 3.7908 10.3526 3.89172C10.4075 3.98119 10.4479 4.07873 10.4724 4.18077C10.5 4.29586 10.5 4.41815 10.5 4.66274Z"
        stroke="#667085"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export default SaveIco;
